import { z } from "zod";

export const estadoPromesaEnum = ["activa", "cumplida", "vencida", "cancelada"] as const;
export type EstadoPromesa = (typeof estadoPromesaEnum)[number];

export const ESTADO_PROMESA_LABEL: Record<EstadoPromesa, string> = {
  activa: "Activa",
  cumplida: "Cumplida",
  vencida: "Vencida",
  cancelada: "Cancelada",
};

export const ESTADO_PROMESA_COLOR: Record<EstadoPromesa, string> = {
  activa: "bg-amber-100 text-amber-800 ring-amber-200",
  cumplida: "bg-green-100 text-green-800 ring-green-200",
  vencida: "bg-red-100 text-red-800 ring-red-200",
  cancelada: "bg-gray-100 text-gray-700 ring-gray-200",
};

// ── Form: otorgar promesa ───────────────────────────────────────────────
export const promesaCreateSchema = z.object({
  cliente_id: z.string().uuid("Cliente requerido"),
  factura_id: z.string().uuid().optional().nullable(),
  fecha_prometida: z
    .string()
    .min(1, "Fecha requerida")
    .refine((v) => !Number.isNaN(Date.parse(v)), "Fecha inválida"),
  monto_prometido: z.coerce.number().positive("Debe ser mayor a 0"),
  motivo: z.string().max(500).optional().or(z.literal("")),
});
export type PromesaCreateInput = z.infer<typeof promesaCreateSchema>;

// ── Response ────────────────────────────────────────────────────────────
export type Promesa = {
  id: string;
  cliente_id: string;
  cliente_nombre: string | null;
  cliente_codigo: string | null;
  factura_id: string | null;
  factura_folio: string | null;
  fecha_prometida: string;
  monto_prometido: string;
  motivo: string | null;
  estado: EstadoPromesa;
  autorizada_por: string | null;
  autorizada_por_nombre: string | null;
  cumplida_en: string | null;
  cumplida_por_pago_id: string | null;
  cancelada_en: string | null;
  cancelada_por: string | null;
  motivo_cancelacion: string | null;
  cliente_estaba_suspendido: boolean;
  reactivacion_disparada: boolean;
  created_at: string;
  dias_restantes: number | null;
};

export type PromesaListResponse = {
  items: Promesa[];
  total: number;
};
